import React from 'react';
import { Global, css } from '@emotion/react';
import tw, { GlobalStyles as BaseStyles } from 'twin.macro';

const customStyles = css`
  /*
    Theme variables
  */
  body {
    height: auto;
    /* Colors */
    --color-primary: #18da9e;
    --color-primary-deep: #13ae7e;
    --color-ivory: #f8f8f8;
    --color-purple: #9013fe;
    --color-purple-deep: #730fcb;
    --color-blue01: #2444ee;
    --color-blue02: #1450ff;
    --color-darkgray09: #111111;
    --color-darkgray: #121212;
    --color-lightgray: #d2d4d8;
    --color-gray01: #222222;
    --color-gray02: #444444;
    --color-gray03: #666666;
    --color-gray04: #888888;
    --color-gray05: #aaaaaa;
    --color-gray06: #cccccc;
    --color-gray07: #eeeeee;
    --color-gray08: #f4f4f4;
    --color-gray09: #f8f8f8;

    /* Typography */
    --text-6xl: 4rem;
    --text-5xl: 3rem;
    --text-4xl: 2rem;
    --text-3xl: 1.875rem;
    --text-2xl: 1.5rem;
    --text-xl: 1.25rem;
    --text-lg: 1.125rem;
    --text-base: 1rem;
    --text-sm: 0.875rem;
    --text-xs: 0.75rem;
    --line-height-base: 1.5;
    --font-bold: 700;
    --font-normal: 500;
    --font-light: 400;
    --font-extralight: 300;

    /* Body Styles */
    ${tw`
      bg-color-gray01
      overflow-x-hidden
      h-screen
      m-0
    `}

    img,
    svg {
      pointer-events: none;
    }

    img,
    svg,
    button,
    a {
      -webkit-tap-highlight-color: transparent;
      -webkit-touch-callout: none;
      user-select: none;
      appearance: none;
      outline: none;
    }
  }

  /* Scroll Smooth */
  html {
    ${tw`
      scroll-behavior[smooth]
    `}
  }
`;

const GlobalStyles = () => (
  <>
    <BaseStyles />
    <Global styles={customStyles} />
  </>
);

export default GlobalStyles;
